<template>
    <div class="story-maker-sticker story-maker-sticker-link">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish">Terminé</p>
        <div class="sticker-link">
           <div class="icon"></div>
            <p>{{ text || link }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            link: String,
            text: String
        },
    }
</script>
